import '@/prototypes/array';

export default {
    name: 'system',

    namespaced: true,

    state: {
        siteID: null,
        systems: null,
        system: null
    },

    getters: {
        siteID(state) {
            return state.siteID;
        },
        systems(state) {
            return state.systems;
        },
        system(state) {
            return state.system;
        }
    },

    mutations: {
        SITEID(state, siteID) {
            state.siteID = siteID;
            if (!state.siteID) return;
        },
        SYSTEMS(state, systems) {
            state.systems = systems;
            if (!state.systems) return;
        },
        SYSTEM(state, system) {
            state.system = system;
            if (!state.system) return;
        },
        UPDATE_TICKETS(state, data) {
            if (state.system) {
                if (state.system.id == data.system.id) {
                    state.system.ticketsCount++;
                    state.system.supportTickets.push(data.ticket);
                }
            }

            if (!state.system) return;
        },
        RESET_STATE(state){
            state.siteID = null;
            state.systems = null;
            state.system = null;
        }
    },

    actions: {
        siteID({ commit }, siteID) {
            commit('SITEID', siteID);
        },
        systems({ commit }, systems) {
            commit('SYSTEMS', systems);
        },
        system({ commit }, system) {
            commit('SYSTEM', system);
        },
        updateTickets({ commit }, data) {
            commit('UPDATE_TICKETS', data);
        },
        resetState({commit}){
            commit('RESET_STATE');
        }
    }
};